import React from "react";
import Navbar from "../components/Navbar";
import { motion } from "framer-motion";

const TermsOfUse = () => {
  const lastUpdated = "October 26, 2025";

  return (
    <>
      <Navbar />
      <div className="min-h-screen bg-gray-50 py-16 px-4 mt-10">
        <div className="max-w-4xl mx-auto">
          <motion.h1
            className="text-3xl sm:text-4xl font-extrabold text-center text-transparent bg-clip-text bg-gradient-to-r from-purple-800 to-pink-500 mb-4"
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
          >
            Terms of Use
          </motion.h1>

          <p className="text-sm text-gray-500 text-center mb-8">Last updated: {lastUpdated}</p>

          <div className="bg-white rounded-2xl shadow-md p-6 space-y-6">
            <section>
              <h2 className="text-lg font-semibold text-gray-800 mb-2">Acceptance of Terms</h2>
              <p className="text-gray-600 leading-relaxed">
                By accessing or using our site and services, you agree to these Terms of Use. If you do not agree, please do not use our services.
              </p>
            </section>

            <section>
              <h3 className="text-lg font-semibold text-gray-800 mb-2">Use of Services</h3>
              <p className="text-gray-600 leading-relaxed">
                You agree to use our services lawfully and not to abuse the platform. You are responsible for maintaining the confidentiality of account credentials.
              </p>
            </section>

            <section>
              <h3 className="text-lg font-semibold text-gray-800 mb-2">Orders & Payments</h3>
              <p className="text-gray-600 leading-relaxed">
                Product purchases are governed by our ordering process and payment terms. Prices, availability, and delivery estimates are subject to change.
              </p>
            </section>

            <section>
              <h3 className="text-lg font-semibold text-gray-800 mb-2">Intellectual Property</h3>
              <p className="text-gray-600 leading-relaxed">
                All content and trademarks on the site are the property of HLC or its licensors. Unauthorized use is prohibited.
              </p>
            </section>

            <section>
              <h3 className="text-lg font-semibold text-gray-800 mb-2">Limitation of Liability</h3>
              <p className="text-gray-600 leading-relaxed">
                To the maximum extent permitted by law, HLC is not liable for indirect or consequential damages arising from your use of the site.
              </p>
            </section>

            <section>
              <h3 className="text-lg font-semibold text-gray-800 mb-2">Governing Law</h3>
              <p className="text-gray-600 leading-relaxed">
                These terms are governed by the applicable laws where HLC operates. Any disputes shall be resolved in the relevant courts.
              </p>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

export default TermsOfUse;
